import { Injectable, signal } from '@angular/core';
import {
  Customer,
  ProjectStatus,
  ItemStatus,
  Loading,
  FinancialStatus,
  Setting,
  Supplier,
  Business,
} from 'src/app/models';
import { BehaviorSubject } from 'rxjs';
import { User } from '../dtos/user.dto';

@Injectable({ providedIn: 'root' })
export class State {
  public customer: Customer;
  public projectStatus: Array<ProjectStatus> = [];
  public itemStatus: Array<ItemStatus> = [];
  public financialStatus: Array<FinancialStatus> = [];
  public suppliers: Array<Supplier> = [];
  public settings: Array<Setting> = [];
  public users: User[] = []; // Array<User>
  public businesses: Business[] = [];
  public systems = [];
  public headquarters;
  technicians: Array<any> = [];
  observableCustomer: any;
  showDeadStatus: any;
  showPrice: any;
  firstProjectStatusCart = 0;
  firstProjectStatusWorkflow = 0;
  firstProjectStatusAccount = 0;
  firstFinancialStatusWorkflow = 0;
  firstFinancialStatusCart = 0;
  firstItemStatusCart = 0;
  firstItemStatusWorkflow = 0;
  loading: BehaviorSubject<Loading>;
  dealerComission: any;
  invoiceSidebar = signal({
    visible: false,
    data: null,
  });
  useClientFeedbackModal = false;

  private lastUsedLocationByProject: Record<
    string,
    { location: string; sublocation: string }
  > = {};

  setLastLocation(
    projectId: string,
    location: string,
    sublocation: string
  ): void {
    this.lastUsedLocationByProject[projectId] = { location, sublocation };
  }

  getLastLocation(projectId: string): string {
    return this.lastUsedLocationByProject[projectId]?.location ?? '';
  }

  getLastSublocation(projectId: string): string {
    return this.lastUsedLocationByProject[projectId]?.sublocation ?? '';
  }

  constructor() {
    let showDeadStatus =
      localStorage.getItem('showDeadStatus') === 'false' ? false : true;

    this.observableCustomer = new BehaviorSubject<Customer>(this.customer);
    this.showDeadStatus = new BehaviorSubject<boolean>(showDeadStatus);
    this.showPrice = new BehaviorSubject<boolean>(false);
    this.loading = new BehaviorSubject<Loading>({
      spinner: false,
      message: 'route',
    });
    this.dealerComission = new BehaviorSubject<number>(0);
  }
}
